import "./TopMenuLayout.css";

function TopMenuLayout ( props ) {

    const { children } = props;

    return (

        <>
            { children }
        </>

    );

}

export default TopMenuLayout;
